(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.product-title-link--underline p';
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const resizeObservers = new WeakMap();
    let dynamicRefreshQueued = false;

    function rememberOriginalTitle(title) {
      if (!title.dataset.originalTitle) {
        title.dataset.originalTitle = title.textContent.trim();
      }
    }

    function restoreOriginalTitle(title) {
      rememberOriginalTitle(title);
      title.textContent = title.dataset.originalTitle;
    }

    function buildAnimatedLines(title) {
      rememberOriginalTitle(title);

      const originalTitle = title.dataset.originalTitle;
      const words = originalTitle.split(/\s+/).filter(Boolean);

      title.textContent = '';

      words.forEach((word, index) => {
        const wordElement = document.createElement('span');
        wordElement.className = 'product-title-measure-word';
        wordElement.textContent = `${index ? ' ' : ''}${word}`;
        title.appendChild(wordElement);
      });

      const measuredWords = [...title.querySelectorAll('.product-title-measure-word')];
      const lines = [];

      measuredWords.forEach((wordElement) => {
        const top = Math.round(wordElement.getBoundingClientRect().top);
        const currentLine = lines[lines.length - 1];

        if (!currentLine || Math.abs(currentLine.top - top) > 2) {
          lines.push({ top, words: [wordElement.textContent.trim()] });
        } else {
          currentLine.words.push(wordElement.textContent.trim());
        }
      });

      title.textContent = '';

      lines.forEach((line, index) => {
        const lineElement = document.createElement('span');
        lineElement.className = 'product-title-animated-line';
        lineElement.style.setProperty('--product-title-line-index', index);
        lineElement.textContent = line.words.join(' ');
        title.appendChild(lineElement);

        if (index < lines.length - 1) {
          title.appendChild(document.createElement('br'));
        }
      });
    }

    function disconnectResizeObserver(title) {
      const observer = resizeObservers.get(title);

      if (observer) {
        observer.disconnect();
        resizeObservers.delete(title);
      }
    }

    function initializeAnimatedTitles(root = document) {
      root.querySelectorAll(selector).forEach((title) => {
        rememberOriginalTitle(title);

        /* 手机 / 触屏端：完全恢复 Horizon 原生自动换行，不插入 <br> */
        if (!hoverQuery.matches) {
          disconnectResizeObserver(title);
          restoreOriginalTitle(title);
          return;
        }

        /* 桌面鼠标端：保留原来的逐行悬浮下划线动画 */
        buildAnimatedLines(title);

        if (!resizeObservers.has(title) && 'ResizeObserver' in window) {
          let previousWidth = Math.round(title.getBoundingClientRect().width);

          const observer = new ResizeObserver(() => {
            if (!hoverQuery.matches) {
              disconnectResizeObserver(title);
              restoreOriginalTitle(title);
              return;
            }

            const currentWidth = Math.round(title.getBoundingClientRect().width);

            if (currentWidth !== previousWidth) {
              previousWidth = currentWidth;
              buildAnimatedLines(title);
            }
          });

          observer.observe(title);
          resizeObservers.set(title, observer);
        }
      });
    }

    function refreshAllTitles() {
      initializeAnimatedTitles(document);
    }

    /*
     * 推荐商品由 product-recommendations.js 在页面加载完成后异步插入。
     * DOMContentLoaded 和 shopify:section:load 都捕捉不到这次更新，
     * 因此监听新增节点，并只在发现新的商品标题时补做初始化。
     */
    function scheduleDynamicRefresh() {
      if (dynamicRefreshQueued) return;

      dynamicRefreshQueued = true;

      requestAnimationFrame(() => {
        dynamicRefreshQueued = false;
        refreshAllTitles();
      });
    }

    const dynamicTitleObserver = new MutationObserver((mutations) => {
      const hasNewTitle = mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) =>
          node.nodeType === 1 &&
          (node.matches(selector) || node.querySelector(selector))
        )
      );

      if (hasNewTitle) {
        scheduleDynamicRefresh();
      }
    });

    dynamicTitleObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshAllTitles);
    } else {
      refreshAllTitles();
    }

    if (hoverQuery.addEventListener) {
      hoverQuery.addEventListener('change', refreshAllTitles);
    } else if (hoverQuery.addListener) {
      hoverQuery.addListener(refreshAllTitles);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAnimatedTitles(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
